// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3MVnN","inner":"Footer_inner__Mqt-l","nextIcon":"Footer_nextIcon__m5FnW","innerLeft":"Footer_innerLeft__2k516"};